import { render, staticRenderFns } from "./AvatarWrapperSmall.vue?vue&type=template&id=60061b7d&scoped=true&"
import script from "./AvatarWrapperSmall.vue?vue&type=script&lang=js&"
export * from "./AvatarWrapperSmall.vue?vue&type=script&lang=js&"
import style0 from "./AvatarWrapperSmall.vue?vue&type=style&index=0&id=60061b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60061b7d",
  null
  
)

export default component.exports